import { render, staticRenderFns } from "./EditAbout.vue?vue&type=template&id=a4dcbd80&scoped=true&"
import script from "./EditAbout.vue?vue&type=script&lang=js&"
export * from "./EditAbout.vue?vue&type=script&lang=js&"
import style0 from "./EditAbout.vue?vue&type=style&index=0&id=a4dcbd80&lang=scss&scoped=true&"
import style1 from "./EditAbout.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4dcbd80",
  null
  
)

export default component.exports